{% block sw_cms_block_acris_blog_image_slider %}
    <div class="sw-cms-block-acris-blog-image-slider">
        <slot name="column"></slot>
    </div>
{% endblock %}
